import { render, staticRenderFns } from "./ConnectedOrganizations.vue?vue&type=template&id=41fe42c0&"
import script from "./ConnectedOrganizations.vue?vue&type=script&lang=js&"
export * from "./ConnectedOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports